// @flow
import { type subscriptionPlanStripeType } from "../FlowTypes/paymentType";

export function getSubscriptionName(plan: subscriptionPlanStripeType) {
  return `${plan.name} - ${plan.price / 100} ${plan.currency.toUpperCase()} / ${
    plan.period
  }`;
}
